import { render, staticRenderFns } from "./LexinKeyboardLangFas.vue?vue&type=template&id=2bec12b6&"
import script from "./LexinKeyboardLangFas.vue?vue&type=script&lang=js&"
export * from "./LexinKeyboardLangFas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports